// @ts-check
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.scss";
import { useForm } from "react-hook-form";
import { login } from "../../api/user";

function Login() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const [enviando, setenviando] = useState(false);
  const [error, seterror] = useState("");

  /**
   * @param {any} dataForm
   */
  const onSubmit = (dataForm) => {
    setenviando(true);
    seterror("");
    login(dataForm.username, dataForm.password)
      .then(() => {
        navigate("/main");
      })
      .catch((error) => {
        seterror(error.message);
      })
      .finally(() => {
        setenviando(false);
      });
  };

  return (
    <div id="Login">
      <div className="TarjetaLogin">
        <div className="Logo">
          <div className="imgF">
            <img src="./IMG/logoletras.svg" alt="Symphony Logo" />
          </div>
        </div>
        <div className="LoginContenedor">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="InputGroup">
              <label htmlFor="username">Usuario</label>
              <input
                id="username"
                type="text"
                placeholder="Ingresa tu usuario"
                {...register("username", {
                  required: "El usuario es requerido",
                })}
                disabled={enviando}
              />
              {errors.username && (
                <span className="ErrorText">
                  {String(errors.username.message)}
                </span>
              )}
            </div>

            <div className="InputGroup">
              <label htmlFor="password">Contraseña</label>
              <input
                id="password"
                type="password"
                placeholder="••••••••"
                {...register("password", {
                  required: "La contraseña es requerida",
                })}
                disabled={enviando}
              />
              {errors.password && (
                <span className="ErrorText">
                  {String(errors.password.message)}
                </span>
              )}
            </div>

            {error && <div className="ErrorMessage">{error}</div>}

            <button type="submit" className="SubmitBtn" disabled={enviando}>
              {enviando ? <div className="Spinner"></div> : "Iniciar Sesión"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
